import { z } from 'zod'

export const updateSiteDesignSchema = z.object({
  logo: z.instanceof(File).optional(),
  logoIcon: z.instanceof(File).optional(),
  logoFavicon: z.instanceof(File).optional(),
  darkMode: z.enum(['default', 'dark_mode']).optional(),
})

export const updateSiteSchema = z.object({
  name: z.string().min(1, 'Name is required').max(50, 'Name is too long'),
  title: z.string().min(1, 'Title is required').max(64, 'Title is too long'),
  description: z.string().max(500, 'Description is too long').optional(),
  tagline: z.string().max(100, 'Tagline is too long').optional(),
  metaTitle: z.string().max(64, 'Meta title is too long').optional(),
  metaDescription: z
    .string()
    .max(155, 'Meta description is too long')
    .optional(),
  slug: z
    .string()
    .min(2, 'Slug is required')
    .max(64)
    .trim()
    .regex(
      /^[a-zA-Z0-9-]+$/,
      'Slug can only contain lowercase letters, numbers, and hyphens',
    )
    .optional(),
})

export const updateSiteAdvancedSchema = z.object({
  copyrightText: z.string().max(200, 'Copyright text is too long').optional(),
  blogLayout: z.enum(['list', 'grid']).optional(),
  blogShowFeatureImage: z.boolean().optional(),
  pageLayout: z.enum(['blog', 'page', 'pagex']).optional(),
  pageId: z.string().max(100, 'Page ID is too long').nullable().optional(),
  appName: z.string().max(50, 'App name is too long').optional(),
  appUrl: z.string().max(500, 'App URL is too long').optional(),
  searchIndexingEnabled: z.boolean().optional(),
})

export const createSiteSchema = z.object({
  name: z.string().min(1, 'Name is required').max(50, 'Name is too long'),
  title: z.string().min(1, 'Title is required').max(64, 'Title is too long'),
  slug: z
    .string()
    .min(3, 'Subdomain must be at least 3 characters')
    .max(63, 'Subdomain is too long')
    .regex(
      /^[a-z0-9]([a-z0-9-]*[a-z0-9])?$/,
      'Subdomain can only contain lowercase letters, numbers, and hyphens (cannot start or end with hyphen)',
    ),
  description: z.string().max(500, 'Description is too long').optional(),
  domain: z.string().max(255).optional(),
})
